import React, { FC } from 'react';
import './error.scss';
import clsx from 'clsx';

interface ErrorMessageProps {
  message?: string;
  className?: string;
}

const ErrorMessage: FC<ErrorMessageProps> = ({ message, className }) => {
  const inputError = clsx(className, {
    input__error: !className,
  });
  return <div className={inputError}>{message}</div>;
};

export default ErrorMessage;
